/**
 * @fileoverview Browser entrypoint for the static Art of Living Campaigns application.
 * @provides React root rendering and the data-router provider.
 * @usedBy web/index.html through Vite.
 * @uses React, React Router, the application router, and design-system foundations.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { router } from "./router";
import "./design-system/foundations/tokens.css";
createRoot(document.getElementById("root")!).render(<StrictMode><RouterProvider router={router} /></StrictMode>);
